import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchMusicServiceLink, deleteMusicServiceLink } from 'redux/music-links/actions';
import { setLastPatchedId } from 'redux/common/actions';

import Parser from 'html-react-parser';

import CommonInputField from 'components/elements/inputs/CommonInputField';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';

import validator from 'validator';

import './MusicServicesListItem.css';

function MusicServicesListItem(props) {
  const {
    item,
    patchMusicServiceLink,
    deleteMusicServiceLink,
    setLastPatchedId,
    patchMusicServiceLinkError,
    lastPatchedId,
  } = props;

  const { t } = useTranslation();

  const validation = value => {
    if (!value) {
      return t('URL should not be empty');
    }
    if (value && !validator.isURL(value, { allow_underscores: true })) {
      return t('Please enter a valid link');
    }
    return null;
  };

  return (
    <div className="music-services-list-item__component">
      <div className="field-wrapper">
        <div className="music-service-icon">
          <div className="icon">{Parser(item.music_service.icon_svg)}</div>
        </div>
        <div className="url">
          <CommonInputField
            key={`music-services-list-item-url-input-key-${item.id}`}
            editIcon
            initialValue={item.url}
            executedFunction={value => {
              const form = new FormData();
              form.append('url', value);
              patchMusicServiceLink(item.id, form);
              setLastPatchedId(item.id);
            }}
            serverErrors={
              lastPatchedId === item.id &&
              patchMusicServiceLinkError &&
              patchMusicServiceLinkError.url
            }
            validationFunction={validation}
          />
        </div>
      </div>

      <div className="actions-wrapper">
        <a
          className="music-service-action-btn"
          href={item.url}
          target="_blank"
          rel="noreferrer"
        >
          {t(item.music_service.button_name)}
        </a>
        <div className="delete">
          <CommonLinkDeleteButton
            mini
            key={`music-service-link-delete-button-key-${item.id}`}
            linkItem={item}
            deleteFunction={deleteMusicServiceLink}
          />
        </div>
      </div>

    </div>
  );
};

MusicServicesListItem.propTypes = {
  patchMusicServiceLink: PropTypes.func.isRequired,
  deleteMusicServiceLink: PropTypes.func.isRequired,
  setLastPatchedId: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  patchMusicServiceLinkError: PropTypes.object,
  lastPatchedId: PropTypes.number,
};

MusicServicesListItem.defaultProps = {
  patchMusicServiceLinkError: null,
  lastPatchedId: null,
};

const mapStateToProps = state => (
  {
    patchMusicServiceLinkError: state.musicLinksReducer.patchMusicServiceLinkError,
    lastPatchedId: state.commonReducer.lastPatchedId,
  }
);

export default connect(
  mapStateToProps,
  {
    patchMusicServiceLink,
    deleteMusicServiceLink,
    setLastPatchedId,
  },
)(MusicServicesListItem);
